import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames'

import Select from '@components/vendor/select.js';

class DistrictSelector extends React.Component {
    static propTypes = {
        districts: PropTypes.arrayOf(PropTypes.object),
        selected: PropTypes.number,
        select: PropTypes.func,
        hasError: PropTypes.bool,
        readOnly: PropTypes.bool
    };

    optionFilter = (option, filterString) => {
        var label = option.label.toLowerCase(),
            alternative_label = option.alternative_label.toLowerCase(),
            filterValue = filterString.toLowerCase();

        return label.indexOf(filterValue) >= 0 || alternative_label.indexOf(filterValue) >= 0;
    };

    render() {
        return (
            <Select name="district_id"
                    value={this.props.selected}
                    options={this.props.districts}
                    onChange={this.props.select}
                    filterOption={this.optionFilter}
                    placeholder=""
                    className={classNames({"has-error": this.props.hasError, "district-selector": true })}
                    noResultsText={i18n.t('funnel.address-form.district-not-found')}
                    scrollMenuIntoView={false}
                    autoBlur={true}
                    disabled={this.props.readOnly || !this.props.districts || this.props.districts.length === 0} />
        );
    }
};

export default DistrictSelector;
